import { HttpStatusCodes } from '@climatepartner/unified-api-lib-http-utils'

export type RawError = {
  error: {
    code: string
    message: string
  }
}

export class UnifiedApiError extends Error {
  constructor(
    public statusCode: HttpStatusCodes,
    public code: string,
    public message: string,
  ) {
    super(`[${code}]: ${message}`)
  }
}

export class UnifiedApiBadRequestError extends UnifiedApiError {
  constructor(
    public statusCode: HttpStatusCodes,
    public code: string,
    public message: string,
  ) {
    super(statusCode, code, message)
  }
}

export class UnifiedApiInternalServerError extends UnifiedApiError {
  constructor(
    public statusCode: HttpStatusCodes,
    public code: string,
    public message: string,
  ) {
    super(statusCode, code, message)
  }
}

export class UnifiedApiClientError extends Error {
  constructor(public code: string, public message: string) {
    super(`[${code}]: ${message}`)
  }
}

export enum CreateOrderErrorCode {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  REQUEST_TIMED_OUT = 'REQUEST_TIMED_OUT',
}

export type UnifiedApiConfiguration = {
  longtermToken: string
  endpointUrl?: string
  authorizationStoragePath?: string
}
